export default __webpack_public_path__ + "static/media/lidarseg.8a4b825c.jpg";